import React from 'react';

export interface MetricsCardProps {
  title: string;
  value: string;
  subLabel: string;
  accent?: boolean;
}

const MetricsCard: React.FC<MetricsCardProps> = ({ title, value, subLabel, accent = false }) => {
  return (
    <div className={`glass-panel glow-hover p-5 flex flex-col justify-between h-32 relative overflow-hidden transition-all duration-300 ${accent ? 'border-accent/30' : ''}`}>
      {accent && (
        <div className="absolute top-0 left-0 w-full h-[2px] bg-accent/80" />
      )}
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-foreground/50 font-medium">
          {title}
        </span>
        {accent && (
          <span className="flex h-2 w-2 relative">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-accent"></span>
          </span>
        )}
      </div>
      <div className="mt-2">
        <span className="text-3xl font-display text-foreground font-semibold tracking-tight num-mono block">
          {value}
        </span>
      </div>
      <div className="mt-1 text-xs text-foreground/40 font-mono truncate">
        {subLabel}
      </div>
    </div>
  );
};

export default MetricsCard;
